function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import ErrorView from './ErrorView';
import { useTypedDispatch, useTypedSelector } from '@profile/src/redux/utils';
import { ellipsisMiddle } from '@profile/src/utils/text';
import { linkWallet, resetLinkWalletError } from '@profile/src/redux/actions';
import { formatErrorMessage } from '../../utils';
import Button from '@profile/src/Components/Button';
import Modal from '@profile/src/Components/PopupModal_V2';
import UsageAgreementModal from '../UsageAgreementModal';
import { logCreateAccountLinkAddress } from '@profile/src/utils/analytic';
import { useTestId, TestableProvider } from '@wolffun/testable-id';

const LinkWalletModal = ({
  isCreateAccount,
  onClose,
  onSuccess
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  const account = useTypedSelector(state => {
    var _state$connectWallet$;

    return ((_state$connectWallet$ = state.connectWallet.accounts) === null || _state$connectWallet$ === void 0 ? void 0 : _state$connectWallet$[0]) || '';
  });
  const dispatch = useTypedDispatch();
  const error = useTypedSelector(state => state.linkWallet.error);
  const loading = useTypedSelector(state => state.linkWallet.loading);
  const [toggleAgreement, setToggleAgreement] = React.useState(false);
  React.useEffect(() => {
    if (isCreateAccount) logCreateAccountLinkAddress();
  }, []);

  const onAgree = async agreement => {
    setToggleAgreement(false);
    if (!agreement) return;

    if (error) {
      onClose();
      dispatch(resetLinkWalletError());
      return;
    }

    const success = await dispatch(linkWallet());

    if (success) {
      onSuccess();
    }
  };

  const onClickConfirm = () => {
    if (!error) {
      setToggleAgreement(true);
    } else {
      onClose();
      dispatch(resetLinkWalletError());
    }
  };

  return !toggleAgreement ? /*#__PURE__*/React.createElement(Modal, _extends({}, generateTestIdProps('last-step', 'close-button'), {
    onClose: onClose
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.step
  }, "last step!"), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "link wallet address"), /*#__PURE__*/React.createElement("span", {
    className: styles.desc
  }, "Your account has been created. Link your address wallet to your account now to to get started"), /*#__PURE__*/React.createElement("span", {
    className: styles.wallet
  }, "Your wallet: ", ellipsisMiddle(account)), !!error && /*#__PURE__*/React.createElement(ErrorView, {
    className: styles.error,
    title: formatErrorMessage(error)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, _extends({
    disabled: loading,
    onClick: onClickConfirm,
    className: styles.btn,
    title: loading ? 'Processing...' : error ? 'CLOSE' : 'LINK'
  }, generateTestIdProps('last-step', error ? 'close-button' : 'link'))))) : /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "agreement"
  }, /*#__PURE__*/React.createElement(UsageAgreementModal, {
    onAgree: onAgree,
    isCreateAccount: isCreateAccount
  }));
};

export default LinkWalletModal;